export default {
  'menu.followUp.schedule': 'Follow-up Schedule',
};